(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared/assets/javascripts/views/searchresults/receiver-search-result.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared/assets/javascripts/views/searchresults/receiver-search-result.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.grassroots.views.ReceiverSearchResult = Marionette.View.extend({
    template: function(data) {
      return svs.grassroots.templates.receiver_search_result(data);
    },
    regions: {
      searchResult: '.js-receiver-search-result'
    },
    collectionEvents: {
      change: 'render',
      append: 'render'
    },
    tagName: 'div',
    className: 'search-result-wrapper',
    onRender: function() {
      this.getRegion('searchResult').show(new svs.grassroots.views.ReceiverSearchResultList({
        collection: this.options.collection
      }));
    }
  });
})(Backbone, _, svs);


 })(window);